<template>
    <div ref="dropdown" class="sort" @focusout="onFocusOut">
        <button class="sort__title" @click="toggleDropdown">
            {{ label }}
            <img src="/nuxt-assets/design2025/icons/sort.svg" />
        </button>
        <ul class="sort__menu" :class="{ 'sort__menu--opened': opened }">
            <li v-for="option in items" :key="option.id">
                <nuxt-link :to="`${option.url}#product-list-filters`" @click="closeDropdown">
                    {{ option.name }}
                </nuxt-link>
            </li>
        </ul>
    </div>
</template>

<script lang="ts" setup>
defineProps<{
    label: string
    items: { id: number; name: string; url: string }[]
}>()

const dropdown = ref<HTMLElement | null>(null)
const opened = ref(false)

const closeDropdown = () => {
    opened.value = false
}

const toggleDropdown = () => {
    opened.value = !opened.value
}

const onFocusOut = (event: any) => {
    if (!dropdown.value?.contains(event.relatedTarget)) {
        closeDropdown()
    }
}
</script>

<style lang="scss" scoped>
.sort {
    position: relative;

    &__title {
        color: $color-grey-500;
        display: flex;
        gap: 10px;
        cursor: pointer;
    }

    &__menu {
        display: none;
        list-style: none;
        position: absolute;
        top: 100%;
        right: 0;
        z-index: 10;
        background: $color-white;
        border: 1px solid $color-grey-300;
        border-radius: 10px;
        padding: 3px;
        width: max-content;
        margin: 5px 0 0;
        text-align: left;

        &--opened {
            display: block;
        }

        li {
            display: block;

            a {
                padding: 7px 30px 7px 10px;
                border-radius: 5px;
                display: block;

                &:hover {
                    background-color: $color-grey-100;
                }
            }
        }
    }
}
</style>
